import React from "react";
import "./GpconPage.css";
import { useNavigate} from "react-router-dom";
import Footer from "../../components/Footer/Footer";

const GpconPage = () => {
const navigate = useNavigate();
    const handleClick = () => {
        navigate('/Registration-Form')
    }
  return (
    <div className="GpconReg-container">
    <div className="GpconReg-registration-container">
         
      <h2 className="registration-title">Register for GPCON 2025!</h2>
      <p className="registration-text">
        Join the largest event organized by the General Practitioner’s Association of Ichalkaranji. 
        Connect, learn, and grow .
      </p>
      <button className="registration-button" onClick={handleClick}>Register Now</button>
    </div>
    <Footer/>
    </div>
  );
};

export default GpconPage;
